import { Button, Flex, Text } from '@auviknetworks/iceberg-ui';
import { Alert, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IntegrationMethodIcon } from 'application/Shared/Components/Avatars/IntegrationMethodIcon';
import { Route } from 'application/Shared/Helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

import { SwitchToAgentDeployment } from './internal/SwitchToAgentDeployment';

const OptionCard = ({
    buttonText,
    disabled,
    intro,
    routeToNextStep,
    title,
    type
}) => {
    const theme = useTheme();
    return (
        <Flex
            data-testid="onboardingQuickScanSelectStepCard"
            flexDirection="column"
            p={4}
            backgroundColor={
                theme.palette.onboarding.quickScanChooseCardBackgroundColor
            }
            justifyContent="space-between"
            alignItems="stretch"
            m={2}
            width={['100%', '100%', '100%', '100%', '50%']}
        >
            <Flex
                data-testid="onboardingQuickScanSelectSubCard"
                flexDirection="column"
                alignItems="stretch"
                height="100%"
            >
                <IntegrationMethodIcon type={type} />
                <Flex
                    flexDirection="column"
                    justifyContent="space-between"
                    alignItems="stretch"
                    height="100%"
                >
                    <Text
                        fontSize={4}
                        color={theme.palette.onboarding.cardBodyText}
                        textAlign="center"
                        my={3}
                    >
                        {title}
                    </Text>
                    <Text
                        fontSize={1}
                        color={theme.palette.onboarding.cardBodyText}
                        my={3}
                        dangerouslySetInnerHTML={{ __html: intro }}
                    />
                </Flex>
            </Flex>
            <Link
                to={routeToNextStep}
                style={{
                    alignSelf: 'center',
                    marginBottom: '16px',
                    marginTop: '16px'
                }}
                data-trackid={`onboardingQuickScanSelectBtn${type}_routeTo`}
            >
                <Button
                    data-testid={`onboardingQuickScanSelectBtn${type}`}
                    data-trackid={`onboardingQuickScanSelectBtn${type}`}
                    disabled={disabled}
                    size="large"
                >
                    {buttonText}
                </Button>
            </Link>
        </Flex>
    );
};

export const QuickScanSelectStep = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { partnerId } = useParams();
    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });

    return (
        <Flex
            alignItems="center"
            data-testid="onboardingQuickScanSelectStep"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Text
                fontSize={['32px', '32px', '32px', 5]}
                color={theme.palette.onboarding.titleTextColor}
                fontWeight="600"
                textAlign="center"
            >
                {t('Onboarding.quickScanSelectStep.title')}
            </Text>
            <Text
                fontSize={4}
                color={theme.palette.onboarding.titleTextColor}
                mt={3}
                textAlign="center"
            >
                {t('Onboarding.quickScanSelectStep.subtitle')}
            </Text>
            <Flex flexDirection="column" mt="8%">
                <Box mb="16px">
                    <Alert
                        severity="warning"
                        icon={false}
                        sx={{ justifyContent: 'center' }}
                    >
                        {t('Clients.integration.billingDisclaimer')}
                    </Alert>
                </Box>
                <Text
                    color={theme.palette.text.primary}
                    fontSize={[3, 3, 3, 4]}
                    mb="4%"
                >
                    {t('Onboarding.quickScanSelectStep.intro')}
                </Text>
            </Flex>
            <Flex
                alignItems="stretch"
                data-testid="onboardingQuickScanSelectCards"
                mt={4}
                flexDirection={['column', 'column', 'column', 'column', 'row']}
                width="100%"
            >
                <OptionCard
                    buttonText={t('Onboarding.select')}
                    intro={t(
                        'Onboarding.quickScanSelectStep.microsoftEntraID.intro'
                    )}
                    routeToNextStep={`${basePartnerRoute}/onboarding/quickScan/configureAD`}
                    title={t(
                        'Onboarding.quickScanSelectStep.microsoftEntraID.title'
                    )}
                    type="microsoftEntraID"
                />
                <OptionCard
                    buttonText={t('Onboarding.select')}
                    intro={t('Onboarding.quickScanSelectStep.google.intro')}
                    routeToNextStep={`${basePartnerRoute}/onboarding/quickScan/configureGoogle`}
                    title={t('Onboarding.quickScanSelectStep.google.title')}
                    type="google"
                />
            </Flex>
            <SwitchToAgentDeployment />
        </Flex>
    );
};
